import { useQuery } from "@apollo/client";

import { GET_STAND_COMMENTS } from "graphql/query/stand-gql";


const useQueryStandComments = ({
    standID,
    page = 1,
    first = 50,
    skip = false,
    orderBy = [ { column: "CREATED_AT", order: "DESC" } ],
}) => {
    const where = {
        column: "MODELABLE_TYPE",
        operator: "EQ",
        value: "STAND",
        AND: [
            {
                column: "MODELABLE_ID",
                operator: "EQ",
                value: standID,
            }
        ]
    };

    const { data, loading, refetch } = useQuery(GET_STAND_COMMENTS, {
        skip: skip || !standID,
        variables: {
            where,
            orderBy,
            first,
            page,
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    return {
        dataStandComments: data?.comments,
        loadingQueryStandComments: loading,
        refetchStandComments: refetch,
    };
};

export default useQueryStandComments;
